import AnimatedPopup from "../core/AnimatedPopup";
import ARIAText from "../core/ARIAText";
import Strings from "../core/data/Strings";
import GameScene from "../scenes/GameScene";
import ARIA from "../utils/ARIA";
import Fonts from "../utils/Fonts";
import GameColors from "../utils/GameColors";
import Overlay from "../utils/Overlay";

export class HelpPopup extends AnimatedPopup {
	private _onResize: () => void;
	scene: GameScene;

	constructor(scene: GameScene, onComplete: () => void) {
		super(scene, 0, 0);

		const overlay = (this._overlay = new Overlay(scene, 0.7, "popupOverlay", 0xffffff));
		this.add(overlay);

		const next = (): void => {
			overlay.destroy();
			popupGroup.destroy();
			onComplete();
		};

		const popupGroup = (this._popupGroup = this.scene.add.container());
		this.add(popupGroup);

		const popup = scene.add.nineSlicedSprite(0, 0, "popupBG", 1325, 920, 50, 50, 50, 50, null, false);
		popupGroup.add(popup);
		popupGroup.setSize(popup.slicedWidth, popup.slicedHeight);

		const headerBG = scene.add.image(0, 0, "popupHeader");
		const headerText = this.scene.add.text(0, 0, Strings.get("HowToPlay").toUpperCase(), {
			color: GameColors.WHITE,
			fontSize: "70px",
			fontFamily: Fonts.MontserratExtraBold,
			align: "center",
		});
		popupGroup.add([headerBG, headerText]);
		this.scene.alignIn.TopCenter(headerText, popup, 0, -25);

		const button = scene.add.button(0, 0, "nextBtn", null, next, null, true);
		popupGroup.add(button);

		const helpTips: Phaser.GameObjects.Container[] = [];
		for (let i = 1; i < 5; i++) {
			const tip = this.createContent(i, i % 2 == 0);
			helpTips.push(tip);
			popupGroup.add(tip);
		}

		this._onResize = (): void => {
			scene.alignIn.Center(popupGroup, scene.viewport);
			scene.alignIn.TopCenter(headerBG, popup, 0, headerBG.height / 2);
			scene.alignIn.Center(headerText, headerBG, 0, 0);

			scene.alignTo.BottomCenter(button, popup, 0, -button.height * 0.75);

			scene.alignIn.Center(helpTips[0], popup, -450, -165);
			scene.alignIn.Center(helpTips[1], popup, -155, -15);
			scene.alignIn.Center(helpTips[2], popup, 155, -165);
			scene.alignIn.Center(helpTips[3], popup, 450, -15);
		};
		this.resize();

		const ariaLayer = "help-popup";
		headerText.setARIA(ariaLayer, true);
		helpTips.forEach((tip) => (tip.getAt(4) as ARIAText).setARIA(ariaLayer));
		button.setARIA("Next", ariaLayer);
		ARIA.showLayer(ariaLayer, true);

		this.intro();
	}

	createContent(index: number, textOnTop: boolean): Phaser.GameObjects.Container {
		const container = this.scene.add.container(0, 0);
		const image = this.scene.add.image(0, 0, "helpImage" + index);
		const numberBG = this.scene.add.image(0, 0, "numberBG");
		const numberText = this.scene.add.text(0, 0, index.toString(), {
			color: "#686ab5",
			fontSize: "42px",
			fontFamily: Fonts.MontserratExtraBold,
			align: "center",
		});
		const textBG = this.scene.add.image(0, 0, "smallTextBG");
		const text = this.scene.add.text(0, 0, Strings.get("HelpTip" + index), {
			color: "#686ab5",
			fontSize: "30px",
			fontFamily: Fonts.MontserratExtraBold,
			align: "center",
			wordWrap: { width: textBG.displayWidth },
		});
		container.add([image, numberBG, numberText, textBG, text]);

		this.scene.alignIn.TopCenter(numberBG, image, 0, -30);
		this.scene.alignIn.Center(numberText, numberBG);

		if (textOnTop) this.scene.alignTo.TopCenter(textBG, image, 0, -20);
		else this.scene.alignTo.BottomCenter(textBG, image, 0, -30);

		this.scene.alignIn.Center(text, textBG, 5);
		return container;
	}

	resize(): void {
		if (this._onResize) this._onResize();
		super.resize();
	}
}
